import { render, staticRenderFns } from "./notice_list.vue?vue&type=template&id=e65daf48&scoped=true&"
import script from "./notice_list.vue?vue&type=script&lang=js&"
export * from "./notice_list.vue?vue&type=script&lang=js&"
import style0 from "./notice_list.vue?vue&type=style&index=0&id=e65daf48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65daf48",
  null
  
)

export default component.exports